import * as React from 'react';
import CTA, { CTATheme } from '../../components/common/CallToAction';
import LocalStorageUtils from '../../utils/LocalStorageUtils';
import { EventNames } from '../../utils/EventTrackerConstants';
import { HeaderWithDescription } from '../../components/common/HeaderWithDescription';
import { IOngoingConsultation } from '../../models/IOngoingConsultation';
import IDoctorProfile from '../../models/IDoctorProfile';
import AppUtils from '../../utils/AppUtils';
import * as _ from 'lodash';
import { Tracker } from '../../utils/Tracker';
import { ActionResult } from '../../../../common/models/IGenericWorkflowActionResult';
import { ISavePlanResponse } from '../../../../common/models/ISavePlanResponse';
import { AppMessages, ConsultationStatusConstant, SUB_SECTIONS_CONTEXT_KEY, toastNotificationAppearance } from '../../utils/AppConstants';
import { IAppointmentScheduleResponse, IPrescription } from '@curefit/care-common';
import IPatientLifestylePlanWrapper from '../../models/patients/IPatientLifestylePlanWrapper';
import { RouteUtils } from '../../routes';

interface EndLCConsultationProps {
    closeModal: () => void,
    appointmentId: number,
    doctorProfile: IDoctorProfile
    doctorType: string,
    patientId: number,
    secondaryUserId: string,
    bookingId: number,
    ongoingConsultation: IOngoingConsultation,
    saveUserPlan: (consultation: IAppointmentScheduleResponse, prescription: IPrescription, patientPlan: IPatientLifestylePlanWrapper, planId: string, isSelf?: boolean, medicalProfile?: any) => Promise<any>,
    updateAppointmentStatus: (bookingId: number, appointmentId: number, status: ConsultationStatusConstant) => Promise<any>,
}

const EndLCConsultation = (props: EndLCConsultationProps) => {

    const { closeModal, ongoingConsultation, appointmentId, bookingId, saveUserPlan, updateAppointmentStatus } = props;

    const bodyContStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 30
    }

    const customCtaStyle = {
        width: 140,
        display: "inline-block",
        animationDuration: "0.4s",
        animationName: "fadeInRight",
        animationFillMode: "both"
    }

    const getMedicalProfileData = () => {
        let medicalProfile: { [key: string]: any } = {};
        const healthTarget = _.pick(ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.HEALTH_TARGET]);
        const otherGoals = _.pick(ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.OTHER_GOALS]);
        const patient_interventions = _.pick(ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.PATIENT_INTERVENTIONS]);
        const dietPlan = _.pick(ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.DIET_PLAN]);
        const fitnessPlan = _.pick(ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.FITNESS_PLAN]);
        const mindfulPlan = _.pick(ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.MINDFULNESS_PLAN]);
        const habits = _.pick(ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.HABITS]);
        const prescInst = _.pick(ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.PRESCRIPTION_INSTRUCTIONS]);
        if (!_.isEmpty(healthTarget)) medicalProfile = { ...medicalProfile, ...healthTarget };
        if (!_.isEmpty(otherGoals)) medicalProfile = { ...medicalProfile, ...otherGoals };
        if (!_.isEmpty(patient_interventions)) medicalProfile = { ...medicalProfile, ...patient_interventions };
        if (!_.isEmpty(dietPlan)) medicalProfile = { ...medicalProfile, ...dietPlan };
        if (!_.isEmpty(fitnessPlan)) medicalProfile = { ...medicalProfile, ...fitnessPlan };
        if (!_.isEmpty(mindfulPlan)) medicalProfile = { ...medicalProfile, ...mindfulPlan };
        if (!_.isEmpty(habits)) medicalProfile = { ...medicalProfile, ...habits };
        if (!_.isEmpty(prescInst)) medicalProfile = { ...medicalProfile, ...prescInst };
        return medicalProfile
    }

    const completeSugarLC = () => {
        let { ongoingConsultation } = props;
        let consultation = ongoingConsultation.appointmentSchedule;
        let planId = !_.isEmpty(ongoingConsultation.planMeta) ? ongoingConsultation.planMeta._id : null;
        const medicalProfile = getMedicalProfileData();
        let patientPlan = AppUtils.isLifeStyleConsultation(ongoingConsultation.appointmentSchedule) ? medicalProfile : ongoingConsultation.medicalProfile.currentConsultationData;
        saveUserPlan(consultation, null, patientPlan, planId, null, medicalProfile).then((planSaveResponse: ISavePlanResponse) => {
            if (planSaveResponse.status === ActionResult.SUCCESS) {
                Tracker.track(EventNames.Plan_Save_Successful, { appointmentId: appointmentId });
                updateAppointmentStatus(bookingId, appointmentId, ConsultationStatusConstant.COMPLETED).then(_ => {
                    RouteUtils.navigateToDashboard();
                });
            }
            else {
                return Promise.reject(planSaveResponse)
            }
        }).then(() => {
            Tracker.track(EventNames.Prescription_Upload_Done, { appointmentId: appointmentId });
        }).catch((error: any) => {
            Tracker.track(EventNames.Plan_Save_Error, { appointmentId: appointmentId });
            let errorMsg = AppMessages.SAVE_PRESCRIPTION_UNSUCCESSFUL
            if (!_.isEmpty(error) && !_.isEmpty(error.workflowStates)) {
                errorMsg += ": " + AppUtils.getWorkflowFailureError(error.workflowStates);
            }
            AppUtils.triggerToastNotification(errorMsg, toastNotificationAppearance.error)
        });
    }

    return (
        <React.Fragment>
            <HeaderWithDescription text={""} description={"Are you sure you want to end ongoing consultation?"} />
            <div className={"body-container"} style={bodyContStyle}>
                {
                    <React.Fragment>
                        <CTA
                            innerText={"Cancel"}
                            theme={CTATheme.SECONDARY}
                            onClick={() => {
                                closeModal();
                            }}
                            customStyle={customCtaStyle} />
                        <CTA
                            innerText={"End"}
                            theme={CTATheme.PRIMARY}
                            onClick={() => {
                                LocalStorageUtils.setClickEvents({ section: EventNames.Complete_Prescription, widget: "Plan", field: EventNames.Complete })
                                completeSugarLC();
                            }}
                            customStyle={customCtaStyle} />
                    </React.Fragment>
                }
            </div>
        </React.Fragment>
    )
}

export default EndLCConsultation;
